import api from "@/services/api";
import apiEndpoints from "@/services/apiEndpoints";
import _ from "lodash";

export const categoryDefinitions = {
  data() {
    return {
      // raw data from api
      cdRaws: {},
      debug: 0,
    };
  },
  methods: {
    initDefinitions() {
      return [
        {
          key: "",
          label: this.$t("b075.search.definitions"),
        },
      ];
    },

    initCategorys() {
      return [
        {
          key: "",
          label: this.$t("b075.search.categorys"),
        },
      ];
    },
    initTypes() {
      return [
        {
          key: "",
          label: this.$t("b075.search.types"),
        },
      ];
    },

    async getCategoryDefinitions() {
      let respApi = null;
      if (this.debug) {
        apiEndpoints.getCategoryDefinitions = "http://localhost:3000/a008";
        respApi = await api.get(apiEndpoints.getCategoryDefinitions);
      } else {
        respApi = await api.post(apiEndpoints.getCategoryDefinitions, {});
      }
      // console.log(
      //   "apiEndpoints.getCategoryDefinitions",
      //   apiEndpoints.getCategoryDefinitions
      // );
      this.cdRaws = JSON.parse(respApi.data.category);
      return respApi;
    },

    cdGetDefinitions() {
      let cdCateDefinions = this.initDefinitions();
      for (let cd in this.cdRaws) {
        let oneCD = {
          key: cd,
          label: cd,
        };
        cdCateDefinions.push(oneCD);
      }
      return cdCateDefinions;
    },
    cdGetCategorys(cd) {
      let c = this.initCategorys();
      if (cd == "") {
        return c;
      }
      this.cdRaws[cd].forEach((e) => {
        for (let item in e) {
          let onItem = {
            key: item,
            label: item,
          };
          c.push(onItem);
        }
      });

      return c;
    },
    async cdGetCategorysForDefinition(cd) {
      let c = [];
      if (cd) {
        c = [];
        await this.cdRaws[cd].forEach((e) => {
          for (let item in e) {
            c.push(item);
          }
        });
      } else {
        for (const key in this.cdRaws) {
          // eslint-disable-next-line
          if (this.cdRaws.hasOwnProperty(key)) {
            const element = await this.cdRaws[key];
            element.forEach((e) => {
              for (let item in e) {
                c.push(item);
              }
            });
          }
        }
        c = c.filter(function(item, pos) {
          return c.indexOf(item) == pos;
        });
      }
      return c;
    },
    cdGetTypes(cd, cate) {
      let t = this.initTypes();
      this.cdRaws[cd].forEach((e) => {
        for (let item in e) {
          if (item == cate) {
            let _types = _.map(e[cate], "type").map((i) => {
              return { key: i, label: i };
            });
            t = _.concat(t, _types);
            break;
          }
        }
      });
      return t;
    },
  },
};

export default categoryDefinitions;
